<template>
    <!-- Main Content -->
    <div
        class="w-full rounded-lg flex flex-col justify-center items-center p-8 mt-6"
    >
        <HeaderIcon>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#5F6D7E" style="opacity:1;"><path  d="M14 14.252V22H4a8 8 0 0 1 10-7.748M12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6m6 4v-3.5l5 4.5l-5 4.5V19h-3v-2z"/></svg>
        </HeaderIcon>

        <!-- Form Section -->
        <div class="w-full max-w-sm mt-6 z-50">
            <div class="flex flex-col items-center justify-center">
                <div class="text-2xl text-center font-medium text-primary-font">
                    Enter Referral Code
                </div>
                <div class="text-sm text-center text-primary-gray">
                    A referral code is required to get to the next step.
                </div>
            </div>
            <form @submit.prevent="validateReferralCode" class="z-50 mt-8">
                <div class="mb-4">
                    <label
                        for="referralCode"
                        class="text-sm font-semibold text-primary-font"
                    >
                        Enter Referral Code
                    </label>
                    <input
                        id="referral_code"
                        type="text"
                        v-model="formData.referral_code"
                        placeholder="Enter referral code"
                        class="mt-1 block text-text-soft w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-[#41AE49] focus:border-[#41AE49]"
                    />
                    <p
                        v-if="validationErrors.referral_code"
                        class="text-red-500 text-sm mt-2"
                    >
                        {{ validationErrors.referral_code }}
                    </p>
                </div>

                <!-- Continue Button -->
                <button
                    :disabled="isLoading"
                    type="submit"
                    class="w-full py-2 px-4 bg-primary-green text-white text-sm font-medium rounded-lg focus:outline-none focus:ring-2 focus:ring-[#41AE49] hover:bg-green-700 transition"
                >
                    <span v-if="isLoading">Processing...</span>
                    <span v-else>Continue</span>
                </button>

                <!-- Get Referral Code Modal Trigger -->
                <div class="my-4">
                    <button
                        type="button"
                        @click="showModal = true"
                        class="w-full py-2 px-4 bg-white text-primary-font text-sm font-medium rounded-lg border border-primary-border hover:bg-primary-border focus:outline-none focus:ring-2 focus:ring-[#41AE49]"
                    >
                        Get a Referral Code
                    </button>
                </div>

                <!-- Modal -->
                <div
                    v-if="showModal"
                    class="fixed inset-0 flex items-center justify-center bg-[#5F6D7E33] bg-opacity-100 transition-opacity duration-300 z-30 px-4"
                >
                    <div
                        class="bg-white p-6 rounded-lg shadow-lg max-w-[600px] w-full transform transition-transform duration-300 scale-100"
                    >
                        <h2 class="text-lg font-semibold text-primary-font mb-4">
                            Get a Referral Code
                        </h2>
                        <p class="text-sm text-primary-font mb-6">Greetings,</p>
                        <p class="text-sm text-primary-font mb-6">
                            Amana Market operates on a referral-based system, valuing the connections within our community. If a current member has referred you, we kindly request that you reach out to them to obtain their referral number.
                        </p>
                        <p class="text-sm text-primary-font mb-6">
                            If you haven't received a referral, please don't hesitate to contact us at <span class="font-semibold text-primary-green">0908 839 5550</span> to obtain your unique referral code.
                        </p>
                        <p class="text-sm text-primary-font">
                            Thank you for your understanding and engagement with Amana Market.
                        </p>

                        <div class="flex justify-end mt-4">
                            <button
                                @click="showModal = false"
                                class="py-2 px-4 border border-primary-border font-semibold text-primary-font text-sm rounded-lg"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import HeaderIcon from "./components/HeaderIcon.vue";
import { useSignupWizardStore } from "@/store";
import { storeToRefs } from "pinia";

const signupWizardStore = useSignupWizardStore();

const {isLoading, formData, validationErrors} = storeToRefs(signupWizardStore)
const {validateReferralCode, fetchSignupState} = signupWizardStore

// Reactive state
const showModal = ref(false);

onMounted(async () => {
    await fetchSignupState();
})
</script>
